import React, { Component } from "react"
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import * as T from "../../redux/constants";
import { radiosComponent } from "../../forms/customInput";
import { customInputComponent, customInputSelectComponent } from "../../forms/customInputBronson";
import { getAddressValidation } from "../../redux/MailingAddressSelector/actions";
import { clearErrors } from '../../redux/Errors/actions';
import { mailingAddressValidations } from '../../utils/validations';
import { Modal } from "../Modal/modal";
import { statesInfo } from "../../utils/statesUS";

class UpdateAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditAddress: false,
      addressContinue: false,
      isModalOpen: false,
      radioOptionsValue: "suggestedAddress",
    }
  }
  componentDidMount(){
    this.props.clearErrors();
  }
  componentDidUpdate() {
    mailingAddressValidations();
  }

  validate() {
    return Yup.object().shape({
      addressLine1: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR))
        .matches(/^[#&'"!.0-9a-zA-Z \s,-]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR) })
        .max(80, i18n.t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR)),
      addressLine2: Yup.string()
        .matches(/^[#&'"!.0-9a-zA-Z \s,-]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR) })
        .max(80, i18n.t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR)),
      city: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.CITY_ERROR))
        .matches(/^[a-zA-Z ]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.CITY_ERROR) })
        .max(40, i18n.t(rk.CCPA_FORM_ERROR.CITY_ERROR)),
      state: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.STATE_ERROR)),
      postalCode: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.ZIP_CODE_ERROR))
        .matches(/^\d{5}(?:-\d{4})?$/, i18n.t(rk.CCPA_FORM_ERROR.ZIP_CODE_ERROR))
        .max(5, i18n.t(rk.CCPA_FORM_ERROR.ZIP_CODE_ERROR)),
    });
  }

  modalOpen = () => {
    this.setState({
      isModalOpen: true,
      radioOptionsValue: !this.props.suggestedMailingAddress.isAddressFound ? "reEnterAddress" : "suggestedAddress"
    });
  };

  handleAddressValidation = (values) => {
    const equalAddress = (
      this.props.suggestedMailingAddress.isAddressFound &&
      values.addressLine1.toLowerCase() === this.props.suggestedMailingAddress.addressLine1.toLowerCase() &&
      values.city.toLowerCase() === this.props.suggestedMailingAddress.city.toLowerCase() &&
      values.state.toLowerCase() === this.props.suggestedMailingAddress.state.toLowerCase() &&
      values.postalCode.toLowerCase() === this.props.suggestedMailingAddress.postalCode.toLowerCase()
    );

    // If the addresses are the same, we don't show the modal
    if (equalAddress) {
      this.props.saveCorrectedAddress(values);
    } else {
      this.modalOpen();
    }
  };

  getSuggestedAddress() {
    const { t } = this.props;

    return (
      <>
        {t(rk.MAILING_ADDRESS.SUGGESTED_ADDRESS)}  <br />
        <b>
          {this.props.suggestedMailingAddress.addressLine1},{" "}
          {this.props.suggestedMailingAddress.city},{" "}
          {this.props.suggestedMailingAddress.state},{" "}
          {this.props.suggestedMailingAddress.postalCode}
        </b>
      </>
    );
  }

  getEnteredAddress(values) {
    const { t } = this.props;
    return (
      <>
        {t(rk.MAILING_ADDRESS.USE_ENTERED_ADDRESS)}
        <br />
        {values.addressLine1}
        {values.addressLine2 ? `, ${values.addressLine2}` : ''}
        , {values.city}, {values.state}, {values.postalCode}
      </>
    );
  }

  changeAddressVerified = () => {
    this.setState({
      isVerifiedAddressChosen: true
    });
  }

  changeAddressNotVerified = () => {
    this.setState({
      isVerifiedAddressChosen: false
    });
  }

  updateRadioOptionsValue(value) {
    this.setState({
      radioOptionsValue: value
    });
  }

  getModalContent(values, isBadRequest) {
    const { t } = this.props;
    return (
      <div>
        {isBadRequest ? (
          <>
            <p id="strikeitron-error-p">{t(rk.ERROR_STRIKEIRON)}</p>
            <Field
              name="reEnterAddress"
              data-testid="reEnterAddress"
              id="reEnteredAddress"
              radioText={t(rk.MAILING_ADDRESS.REENTER_ADDRESS)}
              onClick={() => {
                this.updateRadioOptionsValue("reEnterAddress");
              }}
              isChecked={this.state.radioOptionsValue === "reEnterAddress"}
              component={radiosComponent}
            />
          </>
        ) : (
          <>
            <p id="strikeitron-error-p">{t(rk.MAILING_ADDRESS.MODAL_TITLE)}</p>
            <Field
              name="suggestedAddress"
              data-testid="suggestedAddress"
              id="suggestedAddress"
              radioText={this.getSuggestedAddress()}
              onClick={() => {
                this.changeAddressVerified();
                this.updateRadioOptionsValue("suggestedAddress");
              }}
              isChecked={this.state.radioOptionsValue === "suggestedAddress"}
              component={radiosComponent}
            />
          </>
        )}

        <Field
          name="enteredAddress"
          data-testid="enteredAddress"
          id="enteredAddress"
          radioText={this.getEnteredAddress(values)}
          onClick={() => {
            this.changeAddressNotVerified();
            this.updateRadioOptionsValue("enteredAddress");
          }}
          isChecked={this.state.radioOptionsValue === "enteredAddress"}
          component={radiosComponent}
        />

      </div>
    );
  }

  onCloseModal = () => {
    this.setState({
      isModalOpen: false
    });
  };

  onContinue = (values, setValues, resetForm) => {
    if (this.state.radioOptionsValue === "reEnterAddress") {
      resetForm({
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        reportCheck: true
      });
      this.onCloseModal();
    } else {
      this.setState({ isModalOpen: false }, () => {
        if (this.state.radioOptionsValue === "enteredAddress") {
          this.props.saveCorrectedAddress(values);
        } else {
          const updatedValues = {
            ...values,
            addressLine1: (this.props.suggestedMailingAddress.addressLine1).trim(),
            addressLine2: "",
            city: (this.props.suggestedMailingAddress.city).trim(),
            state: this.props.suggestedMailingAddress.state,
            postalCode: this.props.suggestedMailingAddress.postalCode
          };
          setValues(updatedValues);
          this.props.saveCorrectedAddress(updatedValues);
        }
      });
    }
  };

  getModalFooter(values, setValues, resetForm) {
    const { t } = this.props;
    return (
      <div id='continue-button' className="state-btn">
        <button
          className="c-btn"
          onClick={() => this.onContinue(values, setValues, resetForm)}
          disabled={this.state.radioOptionsValue === ""}
          data-testid="continue-btn"
        >
          <span className="c-btn__text">
            {t(rk.BUTTON.CONTINUE)}
          </span>
        </button>
      </div>
    );
  }

  handleButtonDisable = (values) => {
    return !(values.addressLine1 && values.city && values.state && values.postalCode);
  }

  render() {
    return (
      <div className={`right-to-correct-row ${this.state.isEditAddress && "update-address"}`}>
        {this.state.isEditAddress ? (
          <div>
            <div className="u-m">
              {this.props.correctedAddressState.isCorrectedAddress ? (
                <div className="row-container">
                  <div className="pending-changes-data">
                    <div className="submission-pending-left-container">
                      <div>
                        <span className='right-to-correct-input-label'>{i18n.t(rk.DATA_CORRECTION.ADDRESS_LABEL)}: </span>
                        {this.props.correctedAddressState.addressLine1 + ", "}
                        {this.props.correctedAddressState.addressLine2 && this.props.correctedAddressState.addressLine2 + ", "}
                        {this.props.correctedAddressState.city + ", "}
                        {this.props.correctedAddressState.state + ", "}
                        {this.props.correctedAddressState.postalCode}
                      </div>
                    </div>
                  </div>
                  <div className="right-row_content_right">
                    <div className="submission-pending-right-container">
                      <div className="pending-text-container u-float-left u-mr">
                        <i className="c-icon-list__icon  c-icon  c-icon--[semantic-checkmark]  u-text-success" aria-hidden="true" role="img"></i>
                        <span className="submission-pending-text">{i18n.t(rk.DATA_CORRECTION.PENDING_CHANGES)}</span>
                      </div>
                      <button
                        className="cancel-btn c-btn u-m-none u-float-right"
                        onClick={() => {
                          this.props.clearCorrectedAddress();
                          this.setState({ isEditAddress: false });
                        }}
                        id="cancel-address-changes-btn"
                        data-testid="cancel-address-changes-btn"
                      >
                        <span className="c-btn__text">
                          {i18n.t(rk.BUTTON.CANCEL)}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Formik
                  initialValues={{
                    addressLine1: "",
                    addressLine2: "",
                    city: "",
                    state: "",
                    postalCode: "",
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    await this.props.clearErrors();

                    const addressValidationPayload = {
                      addressLine1: values.addressLine1,
                      addressLine2: values.addressLine2,
                      city: values.city,
                      state: values.state,
                      postalCode: values.postalCode,
                      requestType: "RIGHT_TO_CORRECT",
                      country: "USA"
                    };

                    this.props.getAddressValidation(addressValidationPayload, this.handleAddressValidation, this.props);

                    setSubmitting(false);
                  }}
                  validationSchema={this.validate()}
                >
                  {props => {
                    const { handleSubmit, values, setValues, resetForm } = props;
                    const { suggestedMailingAddress } = this.props;
                    const isBadRequest = !suggestedMailingAddress.isAddressFound;

                    return (
                      <div className="row-container">
                        <div className="o-layout u-m-none">
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="addressLine1"
                              data-testid="addressLine1"
                              type="text"
                              placeHolder={i18n.t(rk.COMMON.ADDRESS_LINE1)}
                              altPlaceholder={(i18n.t(rk.COMMON.ADDRESS_LINE1)).toUpperCase()}
                              id="addressLine1"
                              component={customInputComponent}
                              error={props.errors.addressLine1}
                              helpContent={
                                props.errors.addressLine1 && props.touched.addressLine1
                                  ? props.errors.addressLine1
                                  : ""
                              }
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="addressLine2"
                              data-testid="addressLine2"
                              type="text"
                              placeHolder={i18n.t(rk.COMMON.ADDRESS_LINE2)}
                              altPlaceholder={(i18n.t(rk.COMMON.ADDRESS_LINE2)).toUpperCase()}
                              id="addressLine2"
                              component={customInputComponent}
                              error={props.errors.addressLine2}
                              helpContent={
                                props.errors.addressLine2 && props.touched.addressLine2
                                  ? props.errors.addressLine2
                                  : ""
                              }
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="city"
                              data-testid="city"
                              type="text"
                              placeHolder={i18n.t(rk.COMMON.CITY)}
                              altPlaceholder={(i18n.t(rk.COMMON.CITY)).toUpperCase()}
                              id="city"
                              component={customInputComponent}
                              error={props.errors.city}
                              helpContent={
                                props.errors.city && props.touched.city
                                  ? props.errors.city
                                  : ""
                              }
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="state"
                              data-testid="state"
                              placeHolder={(i18n.t(rk.COMMON.SELECT_STATE))}
                              id="state"
                              component={customInputSelectComponent}
                              options={statesInfo}
                              error={props.errors.state}
                              helpContent={
                                props.errors.state && props.touched.state
                                  ? props.errors.state
                                  : ""
                              }
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="postalCode"
                              data-testid="postalCode"
                              type="text"
                              placeHolder={i18n.t(rk.COMMON.ZIP_CODE)}
                              altPlaceholder={(i18n.t(rk.COMMON.ZIP_CODE)).toUpperCase()}
                              id="postalCode"
                              component={customInputComponent}
                              error={props.errors.postalCode}
                              helpContent={
                                props.errors.postalCode && props.touched.postalCode
                                  ? props.errors.postalCode
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <Modal
                          bodyContent={this.getModalContent(values, isBadRequest)}
                          closeModal={this.onCloseModal}
                          footerContent={this.getModalFooter(values, setValues, resetForm)}
                          isModalOpen={this.state.isModalOpen}
                        />
                        <div className="right-row_content_right">
                          <div className="btn-wrapper">
                            <button
                              className="cancel-btn c-btn u-m-none u-mr"
                              onClick={async () => {
                                await this.props.clearErrors();
                                this.setState({ isEditAddress: false });
                              }}
                              id="cancel-update-address-btn"
                              data-testid="cancel-update-address-btn"
                            >
                              <span className="c-btn__text">
                                {i18n.t(rk.BUTTON.CANCEL)}
                              </span>
                            </button>
                            <div className="save-btn-wrapper u-float-right">
                              <button
                                className="u-m-none c-btn"
                                data-testid="save-address-btn"
                                id="save-address-btn"
                                onClick={handleSubmit}
                                disabled={this.handleButtonDisable(values)}
                              >
                                <span className="c-btn__text">
                                  {i18n.t(rk.BUTTON.SAVE)}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }}
                </Formik>
              )}
            </div>

          </div>
        ) : (
          <div className="row-container">
            <div className="u-m right-to-correct-input-label">{i18n.t(rk.DATA_CORRECTION.ADDRESS_LABEL)}</div>
            <div className="right-row_content_right">
              <div className="update-btn-wrapper">
                <button
                  className="update-btn c-btn u-m-none u-mr"
                  onClick={() => { this.setState({ isEditAddress: true }) }}
                  id={`update-address-btn`}
                  data-testid={`update-address-btn`}
                >
                  <span className="c-btn__text">
                    {i18n.t(rk.BUTTON.UPDATE)}
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

UpdateAddress.propTypes = {
  correctedAddressState: PropTypes.object,
  suggestedMailingAddress: PropTypes.object,
  getAddressValidation: PropTypes.func,
  saveCorrectedAddress: PropTypes.func,
  clearCorrectedAddress: PropTypes.func,
  clearErrors: PropTypes.func,
  t: PropTypes.func.isRequired,
};


const mapStateToProps = state => ({
  correctedAddressState: state.rightToCorrectReducer,
  suggestedMailingAddress: state.suggestedCorrectedAddressReducer,
  networkError: state.networkError,
});

const mapDispatchToProps = dispatch => ({
  getAddressValidation: (action, modalProps, historyProps) => dispatch(getAddressValidation(action, modalProps, historyProps)),
  saveCorrectedAddress: values => dispatch({ type: T.RIGHT_TO_CORRECT.UPDATE_ADDRESS, payload: values }),
  clearCorrectedAddress: () => dispatch({ type: T.RIGHT_TO_CORRECT.CLEAR_UPDATED_ADDRESS }),
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UpdateAddress));
